<div class="mc-avatar-tooltip-container" [matTooltip]="tooltip" [matTooltipDisabled]="disabledTooltip || !tooltip">
  <button *ngIf="showAvatar" type="button" class="mc-avatar-container" [disabled]="isImageDisabled()" (click)="onAvatarClicked()">
    <mat-icon class="mc-avatar-icon mc-avatar-icon-bordered" fontSet="project-titan" fontIcon="icon-publication"></mat-icon>
  </button>

  <mc-inline-button *ngIf="showName" class="mc-avatar-name" [disabled]="isNameDisabled()" (clicked)="onAvatarClicked()">{{ name }}</mc-inline-button>
</div>